import { call, put, takeLatest, select } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import {
  INGREDIENT_LIBRARY_LIST_ITEM_REQUEST,
  INGREDIENT_LIBRARY_LIST_CATEGORY_WITH_UNCATEGORIZED_REQUEST,
  INGREDIENT_LIBRARY_PAGE_REQUEST,
  INGREDIENT_LIBRARY_SET_FILTER_ITEM,
  INGREDIENT_LIBRARY_ON_CHANGE_OUTLET_IDS,
  INGREDIENT_LIBRARY_ITEM_LIST_EXPORT,
  INGREDIENT_LIBRARY_ON_CLICK_CREATE_ITEM,
  INGREDIENT_LIBRARY_ON_CLICK_ROW,
  INGREDIENT_LIBRARY_ON_CLICK_CANCEL,
  INGREDIENT_LIBRARY_ON_CLICK_BTN_ITEM_TRACKING,
  INGREDIENT_LIBRARY_ON_CANCEL_ITEM_INVENTORY_ALERT_MODAL,
  INGREDIENT_LIBRARY_ON_CONFIRM_ITEM_INVENTORY_ALERT_MODAL,
  INGREDIENT_LIBRARY_FILL_FORM_DETAIL_ITEM,
  INGREDIENT_LIBRARY_SUBMIT_FORM_UPDATE,
  INGREDIENT_LIBRARY_SUBMIT_FORM_CREATE,
  INGREDIENT_LIBRARY_DELETE_ITEM,
  INGREDIENT_LIBRARY_ON_CLICK_CREATE_NEW_CATEGORY,
  INGREDIENT_LIBRARY_CONFIRM_CREATE_NEW_CATEGORY,
  INGREDIENT_LIBRARY_CANCEL_CREATE_NEW_CATEGORY,
  INGREDIENT_LIBRARY_SET_UNCATEGORIZED,
  INGREDIENT_LIBRARY_ON_SUCCESS_IMPORT,
  INGREDIENT_LIBRARY_ON_CLICK_TRACKING_COGS,
  INGREDIENT_LIBRARY_ON_CLICK_CANCEL_COGS_MODAL,
  INGREDIENT_LIBRARY_ON_CONFIRM_COGS_MODAL,
  INGREDIENT_LIBRARY_EXPORT_FAILED,
} from 'actions/ingredients/library/constants';
import * as apiOutlets from 'api/outlets';
import * as actIngredientLibrary from 'actions/ingredients/library';
import * as apiProfile from 'api/profile';
import { initialize, reset, change } from 'redux-form';
import * as act from 'actions';
import * as actNotif from 'actions/notifications';
import * as apiIngredientLibrary from 'api/ingredients/library';
import { setSelectedOutletIds } from 'actions/actionBar';
import { showPageLoadingSpinner } from 'actions/loadingSpinner';
import * as clevertapIngredientLibrary from 'clevertap/ingredient/library';
import { sortBy } from 'lodash';
import * as apiUploadImage from 'api/s3';
import { setFile } from 'actions/uploadImage';
import { INGREDIENT, INGREDIENT_ALL } from 'utils/uploadS3Constants';
import { getSelectedOutlet } from 'utils/userProperties';
import * as actOutletList from 'actions/outletPages/list';
import {
  constructFormData,
  constructFormDataWithoutId,
} from '../../utils/s3Util';

/** **************************************
 * API Request saga
 *************************************** */

const getLibrariesIngredient = state => state.ingredients.library.libraries;

const getCloneNotification = state =>
  state.outletPages.list.showCloneOutletNotification.notification;

function* getCloneOutletNotification() {
  const notification = yield select(getCloneNotification);
  return notification;
}

function* fillForm(library) {
  yield put(
    initialize('search', {
      categoryId: library.categoryId,
      typeInventoryId: library.typeInventoryId,
      search: library.search,
    })
  );
}

export function* fillFormDetail(request) {
  const {
    payload: { formatFormDetail },
  } = request;
  yield put(
    initialize('library', {
      id: formatFormDetail.id,
      name: formatFormDetail.name,
      unit_id: formatFormDetail.id,
      ingredient_category_id: formatFormDetail.ingredient_category_id,
      in_stock: formatFormDetail.in_stock,
      alert: formatFormDetail.alert,
      stock_alert: formatFormDetail.stock_alert,
      unit_cost: formatFormDetail.unit_cost,
      track_cogs: formatFormDetail.track_cogs,
      cogs: formatFormDetail.cogs,
      time_synchronized: formatFormDetail.time_synchronized,
      is_recipe: formatFormDetail.is_recipe,
      category_name: formatFormDetail.category_name,
      description: formatFormDetail.description,
      business_id: formatFormDetail.business_id,
      outlet_id: formatFormDetail.outlet_id,
    })
  );
}

export function* fillFormLibraryInventory(library) {
  yield put(
    initialize('libraryInventory', {
      in_stock: library.in_stock,
      alert: library.alert,
      stock_alert: library.stock_alert,
    })
  );
}

export function* fillFormCOGS(library) {
  yield put(
    initialize('libraryCOGS', {
      track_cogs: library.id ? library.track_cogs : true,
      cogs: library.cogs,
    })
  );
}

function* setFilterLibrary(request) {
  yield put(actIngredientLibrary.setLibraries({ results: [] }));
  yield put(showPageLoadingSpinner(true));
  const {
    payload: { categoryId, typeInventoryId, keyword },
  } = request;
  yield put(
    actIngredientLibrary.setFilterState(categoryId, typeInventoryId, keyword)
  );
  yield put(act.showProgressBar());
  try {
    yield call(librariesRequest, {
      page: 1,
      categoryId,
      typeInventoryId,
      keyword,
    });
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
    yield put(showPageLoadingSpinner(false));
  }
}

function* fillSearch(profile) {
  let assignedOutletIds = [];
  if (profile.outlet_id.length > 1) {
    assignedOutletIds = [profile.outlet_id[0]];
  } else {
    assignedOutletIds = profile.outlet_id;
  }
  const data = { outletIds: assignedOutletIds };
  yield put(initialize('search', data));
}

export function* onChangeOutletIds(request) {
  yield put(actIngredientLibrary.setLibraries({ results: [] }));
  yield call(closeRightColumn);
  yield put(showPageLoadingSpinner(true));
  const {
    payload: { outletIds },
  } = request;
  try {
    yield put(act.showProgressBar());
    yield call(apiOutlets.patchLogin, { id: outletIds });
    const resProfile = yield call(apiProfile.getProfile);
    yield put(setSelectedOutletIds(outletIds));
    yield put(change('search', 'outletIds', outletIds));
    yield put(actIngredientLibrary.unSetFilterState());
    yield call(fillForm, { categoryId: 0, typeInventoryId: 0, search: '' });
    yield call(fillSearch, resProfile.data);
    yield put(actIngredientLibrary.listCategoryWithUncategorizedRequest());

    yield call(librariesRequest, {
      page: 1,
      categoryId: 0,
      typeInventoryId: 0,
      keyword: '',
    });
    yield put(actOutletList.checkCloningOutletOnProgress());
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
    yield put(showPageLoadingSpinner(false));
  }
}

/**
 * Listen for page request of librarylibrary. This just works like wrapper
 */
export function* pageRequestFlow() {
  yield put(act.showProgressBar());
  yield put(showPageLoadingSpinner(true));
  yield put(actIngredientLibrary.setLibraries({ results: [] }));
  yield put(actIngredientLibrary.setLibraryDetail(null));
  yield put(actIngredientLibrary.setOutlets([]));
  yield put(actIngredientLibrary.setUnits([]));
  yield put(actIngredientLibrary.showColInputInventory(false));
  yield put(actIngredientLibrary.showColInputCOGS(false));
  yield put(reset('library'));
  yield call(closeRightColumn);
  yield put(setFile(null));

  try {
    yield call(fillForm, { categoryId: 0, typeInventoryId: 0, search: '' });
    const response = yield call(apiOutlets.outlets);
    yield put(actIngredientLibrary.setOutlets(response.data));
    const resProfile = yield call(apiProfile.getProfile);
    yield call(fillSearch, resProfile.data);
    yield call(librariesRequest, {
      page: 1,
      categoryId: 0,
      typeInventoryId: 0,
      keyword: '',
    });
    yield put(actIngredientLibrary.listCategoryWithUncategorizedRequest());

    const libraries = yield select(getLibrariesIngredient);

    clevertapIngredientLibrary.ingredientLibraryStart({
      outletIds: [resProfile.data.outlet_id[0]],
      categoryIds: 'all categories',
      inventoryIds: 0,
      totalItems: libraries.total_count,
    });
    yield put(actOutletList.checkCloningOutletOnProgress());
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* getLibraries(params) {
  yield put(act.showProgressBar());
  try {
    const response = yield call(apiIngredientLibrary.getLibraries, params);
    return response;
  } catch (error) {
    // If we get an error we send Redux the appropiate action and return
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
    return false;
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* librariesRequest(request) {
  let categoryId;
  let typeInventoryId;
  let keyword;
  let page;
  let previousLibraries;
  if (request.payload) {
    const requestPayload = request.payload.query;
    const { filterState } = requestPayload;
    previousLibraries = request.payload.previousLibraries;
    categoryId = filterState.categoryId;
    typeInventoryId = filterState.typeInventoryId;
    keyword = filterState.keyword;
    page = requestPayload.page;
  } else {
    categoryId = request.categoryId;
    typeInventoryId = request.typeInventoryId;
    keyword = request.keyword;
    page = request.page;
  }
  const query = {
    page,
    category_id: !parseInt(categoryId) ? '' : categoryId,
    inventory: !parseInt(typeInventoryId)
      ? 'all'
      : typeInventoryId === '1'
      ? 'low'
      : 'out',
    keyword: !keyword ? '' : keyword,
  };

  yield put(act.showProgressBar());
  try {
    const response = yield call(getLibraries, query);
    const librariesResponse = response;
    if (previousLibraries) {
      librariesResponse.results = previousLibraries.concat(response.results);
    }

    yield put(actIngredientLibrary.setLibraries(librariesResponse)); // todo refactor
    yield put(actIngredientLibrary.setTotalPage(response.total_pages));
    yield put(actIngredientLibrary.setCurrentPage(page));
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(showPageLoadingSpinner(false));
    yield put(act.hideProgressBar());
  }
}

/**
 * Listen for listen category request
 * It will fetch category data from the server and set the category state with action
 */
export function* getCategoriesWithUncategorizedFlow() {
  const categories = yield call(
    apiIngredientLibrary.getCategoriesWithUncategorized
  );
  if (categories) {
    yield put(actIngredientLibrary.setUncategorized(categories.data));
    yield put(actIngredientLibrary.setCategories(categories.data));
  }
}

export function* getExportLibrary(request) {
  const {
    payload: { inventoryId, categoryId, keyword },
  } = request;
  const selectedOutlet = yield select(getSelectedOutlet);
  yield put(act.showLoadingSpinner(true));
  try {
    yield put(actIngredientLibrary.startExportIngredient());
    const params = { inventory: inventoryId };
    if (categoryId && categoryId !== '0') {
      params.category_id = categoryId;
    }
    if (keyword) {
      params.keyword = keyword;
    }
    const { data } = yield call(apiIngredientLibrary.getExportLibrary, params);
    yield put(actIngredientLibrary.setIdAsyncJob(data.async_job_id));
    yield put(actIngredientLibrary.setExportingIngredient(true));
    clevertapIngredientLibrary.ingredientLibraryExport(selectedOutlet);
  } catch (error) {
    yield put(actIngredientLibrary.doneExportIngredient());
    yield put(act.showLoadingSpinner(false));
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  }
}

export function* exportLibraryFailed(error) {
  yield put(act.showLoadingSpinner(false));
  yield put(actNotif.error(error.message, yield getCloneOutletNotification()));
}

export function* clickCreateLibrary(request) {
  const {
    payload: { uncategorized },
  } = request;
  yield put(act.showProgressBar());
  yield put(actIngredientLibrary.setLibraryDetail({}));
  yield call(openRightColumn);
  yield put(actIngredientLibrary.showColInputCOGS(false));
  yield put(actIngredientLibrary.showColInputInventory(false));
  yield put(
    initialize('library', {
      id: null,
      name: null,
      unit_id: null,
      ingredient_category_id: uncategorized.id,
      in_stock: 0,
      alert: true,
      stock_alert: 0,
      image: {},
      track_cogs: false,
      cogs: null,
      unit_cost: 0,
      time_synchronized: null,
      is_recipe: false,
      category_name: null,
      description: null,
      business_id: null,
      outlet_id: null,
    })
  );
  yield put(reset('libraryInventory'));
  const units = sortBy(yield call(apiIngredientLibrary.getUnits), 'name');
  yield put(actIngredientLibrary.setUnits(units));
  yield put(act.hideProgressBar());
}

function* openRightColumn() {
  yield put(actIngredientLibrary.openRightColumn());
}

function* closeRightColumn() {
  yield put(actIngredientLibrary.closeRightColumn());
}

export function* clickCancel() {
  yield put(reset('library'));
  yield put(actIngredientLibrary.setLibraryDetail(null));
  yield call(closeRightColumn);
  yield put(setFile(null));
}

export function* clickLibraryRow(request) {
  const {
    payload: { library },
  } = request;
  try {
    yield put(reset('library'));
    yield put(actIngredientLibrary.setLibraryDetail(null));
    yield put(act.showProgressBar());
    yield put(actIngredientLibrary.setLibraryDetail(library));
    const units = sortBy(yield call(apiIngredientLibrary.getUnits), 'name');
    yield put(actIngredientLibrary.setUnits(units));
    const libraryFormat = yield call(formatLibrary, library);
    yield put(initialize('library', { ...libraryFormat }));
    yield call(openRightColumn);
    yield put(setFile(null));
    if (library.id) {
      yield put(actIngredientLibrary.showColInputInventory(true));
      if (library.track_cogs) {
        yield put(actIngredientLibrary.showColInputCOGS(true));
      } else {
        yield put(actIngredientLibrary.showColInputCOGS(false));
      }
    }
    clevertapIngredientLibrary.ingredientLibrarySelect({
      outletIds: library.outlet_id,
      name: library.name,
      category: library.category_name,
      unit: library.unit_name,
    });
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* formatLibrary(library) {
  const libraryFormat = {
    id: library.id,
    name: library.name,
    unit_id: library.unit_id,
    ingredient_category_id: library.ingredient_category_id,
    category_name: library.category_name,
    in_stock: library.in_stock,
    alert: library.alert,
    stock_alert: library.stock_alert,
    image: library.image,
    unit_cost: library.unit_cost,
    track_cogs: library.track_cogs,
    cogs: library.cogs,
    unit_name: library.unit_name,
    time_synchronized: library.time_synchronized,
    is_recipe: library.is_recipe,
    description: library.description,
    business_id: library.business_id,
    outlet_id: library.outlet_id,
  };
  return libraryFormat;
}

export function* onClickBtnLibraryTracking(request) {
  const {
    payload: { previousLibraryForm },
  } = request;
  yield put(actIngredientLibrary.showLibraryInventoryAleryModal());
  yield put(actIngredientLibrary.setPreviousLibraryForm(previousLibraryForm));
  yield call(fillFormLibraryInventory, {
    in_stock: previousLibraryForm.in_stock,
    alert: previousLibraryForm.alert,
    stock_alert: previousLibraryForm.stock_alert,
  });
}

export function* onCancelLibraryInventoryAlertModal() {
  yield put(actIngredientLibrary.hideLibraryInventoryAleryModal());
  yield put(reset('libraryInventory'));
}

export function* submitFormCreate(request) {
  const {
    payload: { values, allOutlet, ingredients, outletId, libraries, image },
  } = request;
  try {
    const valueLibrary = values.library;
    delete valueLibrary.id;
    yield put(act.showProgressBar());
    yield put(actIngredientLibrary.isSubmittingForm(true));
    let postLibraryRes;
    let updatedLibrary;
    if (allOutlet) {
      // upload image
      if (image) {
        const formData = constructFormDataWithoutId(image, INGREDIENT_ALL);
        const resUpload = yield call(apiUploadImage.postNewImage, formData, {});
        const imageUrl = resUpload.data.download_image_url;
        valueLibrary.image = imageUrl;
        valueLibrary.remote_image_url = imageUrl;
      } else {
        // https://mokapos.atlassian.net/browse/PS2-235
        valueLibrary.image = null;
        valueLibrary.remote_image_url = '';
      }

      postLibraryRes = yield call(
        apiIngredientLibrary.postCreateAllOutletLibrary,
        valueLibrary
      );
      const createdLibraries = postLibraryRes.data;
      for (let i = 0; i < createdLibraries.length; i++) {
        if (createdLibraries[i].outlet_id === outletId) {
          updatedLibrary = createdLibraries[i];
          ingredients.unshift(createdLibraries[i]);
        }
      }
    } else {
      valueLibrary.remote_image_url = '';
      valueLibrary.image = null;

      postLibraryRes = yield call(
        apiIngredientLibrary.postLibrary,
        valueLibrary
      );

      if (image) {
        const formData = constructFormData(
          image,
          INGREDIENT,
          postLibraryRes.data.id
        );
        yield call(apiUploadImage.postNewImage, formData, {
          OUTLET_ID: postLibraryRes.data.outlet_id,
        });
      }

      updatedLibrary = yield call(
        apiIngredientLibrary.getLibraryById,
        postLibraryRes.data.id
      );
      ingredients.unshift(updatedLibrary);
    }
    yield put(setFile(null));
    const libraryFormat = yield call(formatLibrary, updatedLibrary);
    yield put(initialize('library', { ...libraryFormat }));
    yield put(actIngredientLibrary.setLibraryDetail(libraryFormat));
    yield put(
      actIngredientLibrary.setLibraries({
        ...libraries,
        results: ingredients,
        total_count: libraries.total_count + 1,
      })
    );
    yield put(
      actNotif.success(
        'Ingredient successfully created.',
        yield getCloneOutletNotification()
      )
    );
    yield put(actIngredientLibrary.onClickRow(libraryFormat));
    clevertapIngredientLibrary.ingredientLibraryCreate({
      allOutlet,
      ingredient: valueLibrary,
    });
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(actIngredientLibrary.isSubmittingForm(false));
    yield put(act.hideProgressBar());
  }
}

export function* submitFormUpdate(request) {
  const {
    payload: { libraryId, values, libraries, image },
  } = request;
  try {
    yield put(act.showProgressBar());
    yield put(actIngredientLibrary.isSubmittingForm(true));

    if (
      !(
        !image &&
        values.library.image &&
        values.library.image !== 'https://placehold.it/100&text=%20'
      )
    ) {
      const formData = constructFormData(image, INGREDIENT, values.library.id);
      const resUpload = yield call(apiUploadImage.postNewImage, formData, {
        OUTLET_ID: values.library.outlet_id,
      });
      const imageUrl = resUpload.data.download_image_url;
      if (imageUrl === '') {
        // backend only accept null when update without image
        values.library.image = null;
      } else {
        values.library.image = imageUrl;
      }
      values.library.remote_image_url = imageUrl;
    }

    yield call(apiIngredientLibrary.putLibraryById, libraryId, values.library);
    const updatedLibraryRes = yield call(
      apiIngredientLibrary.getLibraryById,
      libraryId
    );
    libraries.results.forEach((library, index) => {
      if (updatedLibraryRes.id === library.id) {
        libraries.results[index] = { ...updatedLibraryRes };
      }
    });
    const libraryFormat = yield call(formatLibrary, updatedLibraryRes);
    yield put(initialize('library', { ...libraryFormat }));
    yield put(actIngredientLibrary.setLibraries(libraries));
    yield put(actIngredientLibrary.setLibraryDetail(updatedLibraryRes));
    yield put(
      actNotif.success(
        'Ingredient was successfully updated.',
        yield getCloneOutletNotification()
      )
    );
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(actIngredientLibrary.isSubmittingForm(false));
    yield put(act.hideProgressBar());
  }
}

export function* onConfirmLibraryInventoryAlertModal(request) {
  const {
    payload: { libraryInventoryForm },
  } = request;
  yield put(actIngredientLibrary.showColInputInventory(true));
  yield put(actIngredientLibrary.hideLibraryInventoryAleryModal());
  // change values of library form with values of libraryInventory
  yield put(change('library', 'in_stock', libraryInventoryForm.in_stock));
  yield put(change('library', 'alert', libraryInventoryForm.alert));
  yield put(change('library', 'stock_alert', libraryInventoryForm.stock_alert));
}

export function* deleteLibrary(request) {
  const {
    payload: { libraryDetail, libraries },
  } = request;
  try {
    yield put(act.showProgressBar());
    // remove libraries
    let deletedIndex = -1;
    libraries.results.forEach((plibrary, index) => {
      if (plibrary.id === libraryDetail.id) {
        deletedIndex = index;
      }
    });
    if (deletedIndex !== -1) {
      libraries.results.splice(deletedIndex, 1);
    }
    yield call(apiIngredientLibrary.deleteLibraryByIdV1, libraryDetail.id);
    yield call(closeRightColumn);
    yield put(actIngredientLibrary.setLibraryDetail(null));
    yield put(reset('library'));
    yield put(actIngredientLibrary.hideDeleteModal());
    yield put(
      actIngredientLibrary.setLibrarySummary({
        ...libraries,
        total_count: libraries.total_count - 1,
      })
    );
    yield put(
      actNotif.success(
        'Ingredient was successfully removed.',
        yield getCloneOutletNotification()
      )
    );
    clevertapIngredientLibrary.ingredientLibraryDelete({
      outletIds: libraryDetail.outlet_id,
      name: libraryDetail.name,
      category: libraryDetail.category_name,
      unit: libraryDetail.unit_name,
    });
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* onClickCreateCategory(request) {
  const {
    payload: { category, previousCategories, previousCategoryId },
  } = request;
  yield put(actIngredientLibrary.setNewCategory(category));
  yield put(actIngredientLibrary.setPreviousCategories(previousCategories));
  // push new category since we want to 'manipulate' the view using redux,
  // using id == 0 as 'dummy id' for category
  const categories = [...previousCategories];
  categories.push({
    id: 0,
    name: category,
  });
  yield put(actIngredientLibrary.setCategories(categories));
  yield put(actIngredientLibrary.setPreviousCategoryId(previousCategoryId));
  // wait to make the event dispatched successfully propagated
  yield call(delay, 50);
  yield put(change('library', 'ingredient_category_id', 0));
  if (category) {
    yield put(actIngredientLibrary.showNewCategoryModal());
  }
}

export function* onClickCancelCreateCategory(request) {
  const {
    payload: { previousCategories, previousCategoryId },
  } = request;
  yield put(actIngredientLibrary.setCategories(previousCategories));
  yield put(change('library', 'ingredient_category_id', previousCategoryId));
  yield put(actIngredientLibrary.hideNewCategoryModal());
}

export function* onClickConfirmCreateCategory(request) {
  const {
    payload: { category },
  } = request;
  try {
    yield put(act.showProgressBar());
    const createCategoryRes = yield call(
      apiIngredientLibrary.createIngredientCategory,
      { name: category }
    );
    yield put(
      change('library', 'ingredient_category_id', createCategoryRes.data.id)
    );
    yield put(actIngredientLibrary.listCategoryWithUncategorizedRequest());
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
    yield put(actIngredientLibrary.hideNewCategoryModal());
  }
}

export function* setUncategorized(request) {
  const {
    payload: { categories },
  } = request;
  const uncategorized = categories.find(
    category => category.name === 'Uncategorized'
  );
  yield put(actIngredientLibrary.storeUncategorized(uncategorized));
}

export function* onSuccessImport() {
  yield put(actIngredientLibrary.hideImportModal());
  yield put(actIngredientLibrary.closeRightColumn());
  yield put(
    actNotif.success(
      'Ingredient successfully imported',
      yield getCloneOutletNotification()
    )
  );
  yield put(actIngredientLibrary.pageRequest());
}

export function* onClickBtnTrackCOGS(request) {
  const {
    payload: { previousLibraryForm },
  } = request;
  yield put(actIngredientLibrary.showTrackingCOGSModal());
  yield put(actIngredientLibrary.setPreviousLibraryForm(previousLibraryForm));
  yield call(fillFormCOGS, previousLibraryForm);
}

export function* onClickCancelCOGS() {
  yield put(actIngredientLibrary.hideTrackingCOGSModal());
  yield put(reset('libraryCOGS'));
}

export function* onConfirmCOGS(request) {
  const {
    payload: { libraryCOGSForm, previousLibraryForm, showInputCOGS },
  } = request;
  let show = false;

  yield put(change('library', 'track_cogs', libraryCOGSForm.track_cogs));
  yield put(change('library', 'cogs', libraryCOGSForm.cogs));

  if (previousLibraryForm.id) {
    if (libraryCOGSForm.track_cogs) {
      show = true;
    } else if (libraryCOGSForm.cogs && !previousLibraryForm.track_cogs) {
      yield put(change('library', 'cogs', null));
    }
  } else if (libraryCOGSForm.track_cogs) {
    show = true;
  } else if (libraryCOGSForm.cogs && !previousLibraryForm.track_cogs) {
    yield put(change('library', 'cogs', null));
  }
  yield put(actIngredientLibrary.showColInputCOGS(show));
  yield put(actIngredientLibrary.hideTrackingCOGSModal());
  clevertapIngredientLibrary.cogsTrackingIngredient({
    ingredientList: previousLibraryForm,
    libraryCOGSForm,
    showInputCOGS,
  });
}

export default function* librarySaga() {
  yield takeLatest(
    INGREDIENT_LIBRARY_LIST_CATEGORY_WITH_UNCATEGORIZED_REQUEST,
    getCategoriesWithUncategorizedFlow
  );
  yield takeLatest(INGREDIENT_LIBRARY_SET_FILTER_ITEM, setFilterLibrary);
  yield takeLatest(INGREDIENT_LIBRARY_PAGE_REQUEST, pageRequestFlow);
  yield takeLatest(INGREDIENT_LIBRARY_ON_CHANGE_OUTLET_IDS, onChangeOutletIds);
  yield takeLatest(INGREDIENT_LIBRARY_LIST_ITEM_REQUEST, librariesRequest);
  yield takeLatest(INGREDIENT_LIBRARY_ITEM_LIST_EXPORT, getExportLibrary);
  yield takeLatest(INGREDIENT_LIBRARY_EXPORT_FAILED, exportLibraryFailed);
  yield takeLatest(INGREDIENT_LIBRARY_ON_CLICK_CREATE_ITEM, clickCreateLibrary);
  yield takeLatest(INGREDIENT_LIBRARY_ON_CLICK_CANCEL, clickCancel);
  yield takeLatest(INGREDIENT_LIBRARY_ON_CLICK_ROW, clickLibraryRow);
  yield takeLatest(
    INGREDIENT_LIBRARY_ON_CLICK_BTN_ITEM_TRACKING,
    onClickBtnLibraryTracking
  );
  yield takeLatest(
    INGREDIENT_LIBRARY_ON_CANCEL_ITEM_INVENTORY_ALERT_MODAL,
    onCancelLibraryInventoryAlertModal
  );
  yield takeLatest(
    INGREDIENT_LIBRARY_ON_CONFIRM_ITEM_INVENTORY_ALERT_MODAL,
    onConfirmLibraryInventoryAlertModal
  );
  yield takeLatest(INGREDIENT_LIBRARY_FILL_FORM_DETAIL_ITEM, fillFormDetail);
  yield takeLatest(INGREDIENT_LIBRARY_SUBMIT_FORM_CREATE, submitFormCreate);
  yield takeLatest(INGREDIENT_LIBRARY_SUBMIT_FORM_UPDATE, submitFormUpdate);
  yield takeLatest(INGREDIENT_LIBRARY_DELETE_ITEM, deleteLibrary);
  yield takeLatest(
    INGREDIENT_LIBRARY_ON_CLICK_CREATE_NEW_CATEGORY,
    onClickCreateCategory
  );
  yield takeLatest(
    INGREDIENT_LIBRARY_CONFIRM_CREATE_NEW_CATEGORY,
    onClickConfirmCreateCategory
  );
  yield takeLatest(
    INGREDIENT_LIBRARY_CANCEL_CREATE_NEW_CATEGORY,
    onClickCancelCreateCategory
  );
  yield takeLatest(INGREDIENT_LIBRARY_SET_UNCATEGORIZED, setUncategorized);
  yield takeLatest(INGREDIENT_LIBRARY_ON_SUCCESS_IMPORT, onSuccessImport);
  yield takeLatest(
    INGREDIENT_LIBRARY_ON_CLICK_TRACKING_COGS,
    onClickBtnTrackCOGS
  );
  yield takeLatest(
    INGREDIENT_LIBRARY_ON_CLICK_CANCEL_COGS_MODAL,
    onClickCancelCOGS
  );
  yield takeLatest(INGREDIENT_LIBRARY_ON_CONFIRM_COGS_MODAL, onConfirmCOGS);
}
